/**
 * Talking points the call guide page and its side panel share, written once so the two never
 * drift apart. Agent notes are addressed to the agent; a line in quotes is said to the client,
 * who is told the product's name, never "Series", and never "invest" as what they do
 * (owner, 2026-10-29).
 */

/** Said at the start of a sales call: the Account Executive explains, the client decides. */
export const SALES_CALL_DISCLAIMER_TEXT =
  "On a sales call, say: 'I'll explain how it works; the decision is yours, and I don't give investment or tax advice.'";

/** While the client fills in their file (M-27..M-30, 2026-10-24; blocked countries, 2026-10-28). */
export const ONBOARDING_HELP_TEXTS: readonly string[] = [
  'The client fills in and submits their own file. Never type it or submit it for them.',
  'Only adults who contribute for themselves. If they say they act for someone else, the portal refuses it; do not suggest a different answer.',
  "The ID depends on where they live. Living in Mexico: INE, Mexican passport or INM card; a US or Canadian citizen living in Mexico may use their passport. A Mexico resident cannot use a US or Canadian driver's licence or green card.",
  'A passport from another country is not enough on its own: living in Mexico, they use their INM card.',
  'Never give nationality as a reason for anything. Blocked countries are checked against where they live and who issued their document, never nationality. If the portal refuses them something, do not add a reason of your own.',
  'Living in Mexico with an INM card: they enter the CURP printed on the card. If the card shows none, they give the reason in the form; that does not stop them.',
  'Before the last submit they sign their tax-residence self-certification and declarations. If they change anything afterwards, they sign again.',
];

/** The side panel's shorter list: who fills in the file, which ID, never nationality. */
export const ONBOARDING_HELP_SHORT_TEXTS: readonly string[] = [
  ONBOARDING_HELP_TEXTS[0],
  ONBOARDING_HELP_TEXTS[2],
  ONBOARDING_HELP_TEXTS[4],
];

/** The two things that surprise a client at sign-in (0181; the session limits). */
export const SIGN_IN_HELP_TEXTS: readonly string[] = [
  'The first time they sign in, and again when a new version is published, the first screen is the Terms and Conditions and the privacy notice. They read and accept them themselves.',
  'The session closes after 15 minutes without a click or a key (moving the mouse or scrolling does not count), and always 8 hours after signing in. They just sign in again.',
];

/** Money received over a Series' capacity waits for a place, with no date (M-25, 2026-10-21). */
export const AWAITING_ALLOCATION_TEXT =
  "'Received — awaiting allocation': the money arrived and is waiting for a place. Give no date and no figure. If they want it back, it is a normal withdrawal request.";

/** The Account Executive describes; the client chooses. */
export const DESCRIBE_SERIES_TEXT =
  'Describe each one by its name: its term and its risk level, starting with what they told you they need. They choose. Never recommend one over another, and never open with a figure.';

/** Told before contributing, not only at a withdrawal (R-8, R-11). */
export const EXIT_TERMS_TEXT =
  'Before they contribute, tell them: capital withdrawn before its term ends earns nothing for that term, and the early withdrawal charge applies where there is one.';

export const TAX_QUESTIONS_TEXT = 'Suggest they ask their own tax adviser. Never give tax advice.';
